<div
  data-at-system-locked-error
  class="error-container flex flex-col gap-[16px] justify-start items-start"
>
  <div class="error-title">
    {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.TITLE' | translate }}
  </div>

  <div class="flex flex-col gap-[8px] justify-start items-start">
    <div class="date">{{ installationLocalTimeOfErrorCreatedAt | date: 'short' }}</div>
    <div class="error-description" *ngIf="installationDetailsStore.isMainDeviceHeatPump$ | async">
      {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.DESCRIPTION' | translate }}
    </div>
    <div class="error-description" *ngIf="installationDetailsStore.isMainDeviceBoiler$ | async">
      {{
        '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.GAS_BOILER_DESCRIPTION'
          | translate
      }}
    </div>
  </div>

  <div
    *ngIf="activeErrorsStore.hasAnyActiveErrorDetails$ | async"
    class="repair-now flex flex-row justify-start items-center w-full min-w-full h-full min-h-full"
  >
    <!-- navigate to GTS to check what active errors are on the device -->
    <button
      data-at-gts-more-details
      mat-stroked-button
      appSmallButton
      class="repair-now__btn"
      gtm="onSelect"
      gtmAction="Error details navigate"
      gtmCategory="active error"
      color="secondary"
      [disabled]="connectionStatus === diagnosticsConnectionStatus.LOADING"
      (click)="navigateToErrorDetails()"
    >
      {{
        '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.BUTTON_REDIRECT_TITLE'
          | translate
      }}
    </button>
  </div>
</div>
